import { render } from "./message-box-confirm-cancel.vue?vue&type=template&id=c288a91c&scoped=true&ts=true"
import script from "./message-box-confirm-cancel.vue?vue&type=script&lang=ts"
export * from "./message-box-confirm-cancel.vue?vue&type=script&lang=ts"

import "./message-box-confirm-cancel.vue?vue&type=style&index=0&id=c288a91c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c288a91c"]])

export default __exports__